import React from 'react';

export default (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={props.className ? props.className : "show-entries__icon"}><polyline points="9 18 15 12 9 6" /></svg>
);
